"use client";

import { baseCollectionSchema } from "../../../lib/types/schema/collection/baseCollectionSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyChallengesMostRecent } from "./keyChallengesMostRecent";

export const useRequestChallengesMostRecent = ({
  ...props
}: UseRequestQueryProps = {}) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: baseCollectionSchema,
      urlBackendPath: "/challenges/most-recent",
    },
    queryKey: keyChallengesMostRecent(),
  }),
});
